/*
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 16:00:41
 * @LastEditors: xgx
 * @LastEditTime: 2023-07-17 14:44:43
 */
import req from "@/utils/request";
export const selectMyListPage = (params) => req.post("/site-service/m/platformReservation/sendMeSelectPage", params);
export const myList = (params) => req.post("/site-service/m/platformReservation/selectPage", params);
export const tree = (params) => req.post("/manager-service/m/organization/organTree", params);
export const create = (params) => req.post("/site-service/m/platformReservation/create", params);
export const update = (params) => req.post("/site-service/m/platformReservation/update", params);
export const selectViewData = (params) => req.post("/site-service/m/platformReservation/selectViewData", params);
export const deleteById = (params) => req.post("/site-service/m/platformReservation/delete", params);
export const details = (params) => req.post("/site-service/m/platformReservation/details", params);

